export default "/_next/static/chunks/fonts/Source Sans Pro SemiBold-94f13d0e0d1f9443c8ce1aa4d0a02453.otf";